import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as P } from "react";
import { clsx as f } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { Avatar as M } from "../../Avatars/Avatar.js";
import { Typography as h } from "../../Typography/Typography.js";
import v from "../../Icon/Icon.js";
import w from "../../Badge/Badge.js";
import L from "../../../molecules/Dropdown/components/NoResultMessage.js";
import a from "./styles.module.scss.js";
import S from "../../ListItem/ListItem.js";
import K from "../../Button/Button.js";
import O from "../../../molecules/TagGroup/TagGroup.js";
import z from "../../../../node_modules/lodash/isEmpty.js";
import { c as i } from "../../../../node_modules/react-select/dist/index-641ee5b8.esm.js";
const j = ({ children: e }) => /* @__PURE__ */ t.jsx("div", { className: "w-200 h-200 flex items-center justify-center", children: e }), I = [
  "gray",
  "cyan",
  "orange",
  "greenLight",
  "green",
  "red",
  "violet",
  "pink"
], V = () => {
  const e = Math.floor(Math.random() * I.length);
  return I[e];
}, U = (e) => {
  const { isFocused: s, getValue: n, children: l } = e, {
    destructive: u,
    leadingIcon: x,
    isAvatarList: d,
    size: o,
    testId: c,
    isDisabled: g,
    avatarSrcKey: m,
    labelKey: y,
    valueKey: b,
    readOnly: N,
    isMulti: C
  } = e.selectProps, r = n()[0] || {}, p = (r == null ? void 0 : r.leadingIcon) ?? (x || null);
  return /* @__PURE__ */ t.jsx(i.Control, { ...e, children: /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: f(a.control, a[o], {
        [a.controlFocused]: s,
        [a.destructive]: u && !s,
        [a.disabled]: g,
        [a.textFilled]: !z(r),
        [a.readOnly]: N
      }),
      "data-testid": c,
      children: [
        !d && p && /* @__PURE__ */ t.jsx(j, { children: /* @__PURE__ */ t.jsx(
          v,
          {
            name: p,
            size: "sm",
            className: f({
              "text-color-fg-lighter": !s,
              "text-color-fg-brand-default": s
            })
          }
        ) }),
        !C && (d || (r == null ? void 0 : r[m])) && /* @__PURE__ */ t.jsx(
          M,
          {
            size: "sm",
            imageSrc: r == null ? void 0 : r[m],
            imageAlt: r == null ? void 0 : r[y],
            ...(!(r != null && r[b]) || !(r != null && r[m])) && {
              iconName: "user-03",
              color: "violet",
              type: "icon"
            }
          }
        ),
        l
      ]
    }
  ) });
}, X = (e) => {
  const { data: s, children: n, selectProps: l } = e;
  return /* @__PURE__ */ t.jsx(
    i.SingleValue,
    {
      className: "flex items-center gap-125 h-full",
      ...e,
      children: /* @__PURE__ */ t.jsx("div", { className: "w-full flex items-center gap-125 me-025", children: /* @__PURE__ */ t.jsxs("div", { className: "w-full flex items-center flex-grow gap-100", children: [
        /* @__PURE__ */ t.jsx("div", { className: "w-full flex-grow", children: /* @__PURE__ */ t.jsx(
          h,
          {
            text: s == null ? void 0 : s[l.labelKey],
            variant: "interface/medium/sm",
            textColor: "color/fg/bold",
            className: "whitespace-nowrap overflow-hidden text-ellipsis flex-1"
          }
        ) }),
        (s == null ? void 0 : s[l.subLabelKey]) && /* @__PURE__ */ t.jsx(
          h,
          {
            variant: "interface/default/s",
            text: s == null ? void 0 : s[l.subLabelKey],
            textColor: "color/fg/lighter"
          }
        ),
        !(s != null && s[l.valueKey]) && n
      ] }) })
    }
  );
}, Y = (e) => {
  const { badgeLabel: s, badgeColor: n, badgeLeadingIcon: l } = e.selectProps;
  return /* @__PURE__ */ t.jsx(i.IndicatorsContainer, { ...e, children: /* @__PURE__ */ t.jsxs("div", { className: "flex items-center justify-center h-full", children: [
    s && /* @__PURE__ */ t.jsx(
      w,
      {
        label: s,
        color: n ?? "gray",
        leadingIcon: l,
        size: "small"
      }
    ),
    e.children
  ] }) });
}, Z = (e) => /* @__PURE__ */ t.jsx(
  i.DropdownIndicator,
  {
    ...e,
    className: "ms-075",
    children: /* @__PURE__ */ t.jsx(j, { children: /* @__PURE__ */ t.jsx(
      v,
      {
        name: "chevron-down",
        size: "sm",
        style: {
          transition: "all .3s ease",
          transform: e.selectProps.menuIsOpen ? "rotate(180deg)" : null
        },
        className: "transition ease-in-out text-color-fg-light"
      }
    ) })
  }
), _ = (e) => {
  var s;
  return /* @__PURE__ */ t.jsx(
    i.ClearIndicator,
    {
      ...e,
      className: "h-full flex items-center justify-center ms-075",
      children: /* @__PURE__ */ t.jsx(j, { children: /* @__PURE__ */ t.jsx(
        v,
        {
          name: "delete-filled",
          size: "sm",
          "data-testid": `${(s = e.selectProps) == null ? void 0 : s.testId}-clear-indicator`,
          className: "transition ease-in-out text-color-fg-lightest hover:text-color-fg-bold"
        }
      ) })
    }
  );
}, E = (e) => /* @__PURE__ */ t.jsx(
  i.Input,
  {
    ...e,
    className: "textInput",
    "data-testid": e.selectProps.testId
  }
), ee = (e) => /* @__PURE__ */ t.jsx(
  i.Input,
  {
    ...e,
    "data-testid": e.selectProps.testId
  }
), se = (e) => /* @__PURE__ */ t.jsx(
  i.MenuList,
  {
    ...e,
    className: "!py-0",
    children: e.children
  }
), te = P((e) => {
  delete e.innerProps.onMouseMove, delete e.innerProps.onMouseOver;
  const { isSelected: s, data: n } = e, { leadingIcon: l, switch: u } = n, { isAvatarList: x, itemSize: d, avatarSrcKey: o, subLabelKey: c } = e.selectProps;
  return /* @__PURE__ */ t.jsx(
    i.Option,
    {
      ...e,
      className: "first:mt-0 last:mb-0 mb-025",
      children: /* @__PURE__ */ t.jsx(
        S,
        {
          ...n,
          ...!x && { leadingIcon: l },
          avatarSrc: n == null ? void 0 : n[o],
          text: e.label,
          size: d,
          helperText: n == null ? void 0 : n[c],
          selected: s,
          switch: u
        }
      )
    }
  );
}), ne = (e) => {
  const { hasHelperText: s, footer: n, inputValue: l } = e.selectProps;
  return /* @__PURE__ */ t.jsxs(
    i.Menu,
    {
      ...e,
      className: f(a.menu, s && "!mt-[30px]"),
      children: [
        e.children,
        (n == null ? void 0 : n.label) && /* @__PURE__ */ t.jsx("div", { className: "mx-150 my-075", children: /* @__PURE__ */ t.jsx(
          K,
          {
            label: n.label,
            leadingIcon: n.leadingIcon,
            trailingIcon: n.trailingIcon,
            variant: "outlined",
            onClick: () => n.onClick(l),
            size: "medium",
            className: "!w-full",
            color: n.color
          }
        ) })
      ]
    }
  );
}, le = (e) => {
  const { selectProps: s, setValue: n } = e, { valueKey: l } = s, u = (o, c) => {
    if (o.preventDefault(), o.stopPropagation(), c) {
      const g = s.value.filter(
        (m) => (m == null ? void 0 : m[l]) !== (c == null ? void 0 : c[l])
      );
      n(g);
    }
  }, x = { onMouseDown: u };
  if (e.index > 0) return null;
  const d = s.value.map((o) => {
    const c = s.getOptionLabel(o);
    return {
      ...o,
      label: c,
      prefix: o != null && o[s.avatarSrcKey] ? "avatar" : "none",
      closeIcon: !o.hideCloseIcon,
      onClose: (m) => u(m, o),
      avatarProps: o != null && o[s.avatarSrcKey] ? {
        color: V(),
        type: "initials",
        imageAlt: c,
        imageSrc: o == null ? void 0 : o[s.avatarSrcKey]
      } : void 0
    };
  });
  return /* @__PURE__ */ t.jsx(
    i.MultiValue,
    {
      ...e,
      innerProps: x,
      children: /* @__PURE__ */ t.jsx("div", { className: "py-050", children: /* @__PURE__ */ t.jsx(
        O,
        {
          maxTags: s.menuIsOpen ? s.options.length + s.value.length : s.maxTags,
          tags: d,
          maxTagWidth: s.maxTagsWidth
        }
      ) })
    }
  );
}, oe = (e) => /* @__PURE__ */ t.jsx(i.NoOptionsMessage, { ...e, children: /* @__PURE__ */ t.jsx(L, {}) }), re = (e) => {
  const { size: s } = e.selectProps;
  return /* @__PURE__ */ t.jsx(i.Placeholder, { ...e, children: /* @__PURE__ */ t.jsx(
    h,
    {
      variant: s == "regular" ? "interface/default/sm" : "interface/default/s",
      text: e.children,
      textColor: "color/fg/lightest"
    }
  ) });
}, ie = (e) => {
  const s = document.querySelector(`#${e} .${a.menu}`), n = s == null ? void 0 : s.parentElement, l = s == null ? void 0 : s.cloneNode(!0);
  l && (l.classList.add(a.menuClose), l.addEventListener("animationend", () => {
    n == null || n.removeChild(l);
  }), n == null || n.appendChild(l));
};
export {
  _ as ClearIndicator,
  U as Control,
  Z as DropdownIndicator,
  Y as IndicatorsContainer,
  E as Input,
  ne as Menu,
  se as MenuList,
  le as MultiValue,
  oe as NoOptionsMessage,
  te as Option,
  re as Placeholder,
  ee as SelectInput,
  X as SingleValue,
  ie as onMenuClose
};
//# sourceMappingURL=controls.helper.js.map
